import { default as blue } from './blue';
import { default as dark } from './dark';
import { default as green } from './green';
import { default as grey } from './grey';
import { default as light } from './light';

const getThemeOptions = ({ messages }) => [
  {
    id: 'blue',
    label: messages.readerSettingsThemeBlue,
    value: 'blue'
  },
  {
    id: 'light',
    label: messages.readerSettingsThemeLight,
    value: 'light'
  },
  {
    id: 'dark',
    label: messages.readerSettingsThemeDark,
    value: 'dark'
  },
  {
    id: 'grey',
    label: messages.readerSettingsThemeGrey,
    value: 'grey'
  },
  {
    id: 'green',
    label: messages.readerSettingsThemeGreen,
    value: 'green'
  }
];

const themes = {
  blue,
  dark,
  green,
  grey,
  light
};

export { getThemeOptions, themes };
